module.exports = __webpack_public_path__ + "img/19.2e7dfe68.jpg";